import { getApiBaseUrl } from '../../../utils/apiBase';
import type { NotificationItem } from '../../../types';

type FetchNotificationsResponse = {
  notifications: NotificationItem[];
  hasMore: boolean;
  nextOffset: number;
  remainingCount: number;
  totalCount: number;
};

const fetchUserNotifications = async (
  userId: number,
  limit = 20,
  offset = 0,
): Promise<FetchNotificationsResponse | undefined> => {
  try {
    const params = new URLSearchParams({
      userId: String(userId),
      limit: String(limit),
      offset: String(offset),
    });

    const apiBase = getApiBaseUrl();
    const response = await fetch(
      `${apiBase}/api/notification/getNotification?${params.toString()}`,
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      },
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch notifications: ${response.status}`);
    }

    const data: FetchNotificationsResponse = await response.json();

    return data;
  } catch (error) {
    console.error('Failed to fetch notifications:', error);
  }
};

export default fetchUserNotifications;
